"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrigin = void 0;
const getOrigin = (headers) => {
    const { referer, origin, Origin } = headers;
    const originValue = origin || Origin;
    if (originValue) {
        return originValue;
    }
    if (!referer) {
        return '';
    }
    return referer.match('vanguard.com|np-vanguard.com|vanguard.com.au') ? new URL(referer).origin : '';
};
exports.getOrigin = getOrigin;
